export default __webpack_public_path__ + "static/race-day-5k-square-5bbe182682208fc7353b473563772b8d.png";